import RecoverStep from "./recover_step";
import {AJAX_DATA_TYPE_JSON} from "../utils/recover_consts";

const TEMPLATE = 'expose-cifs-share';

export default class ExposeCifsShare extends RecoverStep {

    constructor() {
        super(TEMPLATE);
    }

    open(data, el, fr, previousStep) {
        data.tmp = {
            isLoading : null,
            isSuccessful : null,
            sharePath : null,
            macSharePath : null,
            applianceOffline : {
                back : "setRecoveryPoint",
                tryAgain : "exposeCifsShare"
            },
            genericError : {
                back : "setRecoveryPoint",
                tryAgain : "exposeCifsShare"
            },
            sliderValue : null
        };
        fr.callMethod("doExpose");
    }

    render(data, el, fr) {
        data.render = {
            sharePath      : data.tmp.sharePath,
            macSharePath   : data.tmp.macSharePath,
            isLoading      : data.tmp.isLoading,
            isSuccessful   : !data.tmp.isLoading && data.tmp.isSuccessful,
            isUnsuccessful : !data.tmp.isLoading && !data.tmp.isSuccessful
        };
    }

    postRender(data, el, fr) {
        $(el).find('.sliderBar').slider({min: 0, max: 9, step: 1, value: 5}).on("slide", function (event, ui) {
            data.tmp.sliderValue = data.tmp.unmountOptions[ui.value][0];
            $(el).find('.sliderDisplay').text(data.tmp.unmountOptions[ui.value][1]);
        });
    }

    close(data, el, fr) {
        if (data.tmp.sliderValue){
            $.post("/share/set_cifs_share_ttl/" + data.tmp.shareId + "/" + data.tmp.sliderValue, function(response){
                if (response.ok && newestClientOverviewManager){
                    newestClientOverviewManager.fetchCifsShares();
                }
            });
        }
    }


    doExpose(data, el, fr) {
        data.tmp.isLoading = true;
        fr.render("exposeCifsShare");

        $.ajax({
            type: "POST",
            url: "/ra/expose_cifs_share/" + data.recovery.appliance_id + "/" + data.recovery.job_id + "/" + data.recovery.pointTs + "000" + "/" + (data.recovery.drive ? data.recovery.drive : "null") ,
            success: function (response) {
                data.tmp.isLoading = false;
                if (!response){
                    fr.goTo("applianceOffline");
                    return;
                } else if(response.ok == false){
                    data.tmp.errorMessage = response.error;
                    data.tmp.errorTitle   = response.title;
                    fr.goTo("genericError");
                    return;
                }
                if (data.tmp.isSuccessful = response.ok){
                    data.tmp.sharePath = response.sharePath;
                    data.tmp.macSharePath = response.macSharePath;
                    data.tmp.unmountOptions = response.unmountOptions;
                    data.tmp.shareId = response.shareId;
                }
                fr.render("exposeCifsShare");
            },
            dataType: AJAX_DATA_TYPE_JSON,
            contentType: "application/json"
        }).fail(fr.defaultAJAXErrorHandler);
    }

    transitionBack(data, el, fr) {
        fr.goTo("setRecoveryPoint");
    }

    transitionTryAgain(data, el, fr) {
        fr.callMethod("doExpose");
    }

    transitionAnother(data, el, fr) {
        const services = data.recovery.services || [];
        data.recovery = { type: 'file_or_folder', via: null, device_name: null, virtualization: null, restore: null, services: services };
        fr.goTo('setAppliance');
    }

}
